
import mixpanel from 'mixpanel-browser';
import { sendPageViewedEvent } from '@/resources/tracking';
import { isBot } from '@/resources/helpers'
export default defineNuxtPlugin((nuxtApp) => {

  if (import.meta.env.SSR) return

  const config = useRuntimeConfig();
  const mixPanelToken = config.public.mixpanel_token;

  const isDev = import.meta.env.DEV;
  const URL = isDev ? 'http://localhost:3000' : ''

  const userAgent = navigator?.userAgent || ''

  if (!isBot(userAgent)) {

    mixpanel.init(mixPanelToken, {
      api_host: `${URL}/api/tracking`,
      persistence: 'localStorage',
      geolocate: true,
      ip: false,
      batch_requests: false,
      record_sessions_percent: 1,
      stop_utm_persistence: true,
      debug: false,
      autocapture: {
        pageview: false,
        click: false,
        input: false,
        scroll: false,
        submit: false,

      }
    });

    // Track page views on route changes
    nuxtApp.$router.afterEach(async (to, from) => {
      const error = useError()
      await sendPageViewedEvent(to, error)
    })

  }
  return {
    provide: {
      mixpanel
    }
  };
})




